import React, { createContext, useContext, ReactNode } from 'react';
import { serviceFactory, ServiceContainer } from '../api/services/service-factory';

// Create context
const ServiceContext = createContext<ServiceContainer | null>(null);

// Provider component
interface ServiceProviderProps {
  children: ReactNode;
}

export const ServiceProvider: React.FC<ServiceProviderProps> = ({ children }) => {
  const services = serviceFactory.getServices();

  return <ServiceContext.Provider value={services}>{children}</ServiceContext.Provider>;
};

// Custom hook to use services
export const useServices = (): ServiceContainer => {
  const context = useContext(ServiceContext);

  if (!context) {
    throw new Error('useServices must be used within a ServiceProvider');
  }

  return context;
};

// Individual service hooks for convenience
export const useCompanionService = () => {
  const { companionService } = useServices();
  return companionService;
};

export const useChatService = () => {
  const { chatService } = useServices();
  return chatService;
};

export const useUserService = () => {
  const { userService } = useServices();
  return userService;
};

export const useAuthService = () => {
  const { authService } = useServices();
  return authService;
};

export const useAudioService = () => {
  const { audioService } = useServices();
  return audioService;
};

// Hook to get current API mode information
export const useApiMode = () => {
  return serviceFactory.getCurrentMode();
};
